import { writable } from 'svelte/store'

async function loadAllData(set) {
  const response = await fetch('./takeSheet1.json')
  const data = await response.json()
  set(data)
}

const createRawDataStore = () => {

  //Default store to undefined
  const { subscribe, set } = writable(undefined);

  //Load the initial data - pass the set function
  loadAllData(set)
  
	return {
    subscribe,
	};
}

export const RawDataStore = createRawDataStore();